import styled, { css } from 'styled-components';

import {
  spaceL,
  spaceXL,
  spaceXXL,
  xdlColorPremiumTertiary,
} from '@xing-com/tokens';

type BottomSheetContentContainerProps = {
  $premiumTheme: boolean;
};

export const BottomSheetContentContainer = styled.div<BottomSheetContentContainerProps>`
  padding: ${spaceXL} ${spaceXXL} ${spaceXL} ${spaceXL};

  ${({ $premiumTheme }) =>
    $premiumTheme &&
    css`
      background: ${xdlColorPremiumTertiary};
    `}

  & p:last-of-type {
    margin-bottom: ${spaceL};
  }
`;
